// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"2029b842","235":"9d7d5df5","246":"0db5e917","259":"16ffd261","453":"257c4c88","733":"d09d9832","827":"efe2aff3","866":"338b2444"}[chunkId] + ".chunk.js";
};